import { selectNavOpen, setOnFlyoutWillClose } from '@redux/navSlice'
import { useAppDispatch, useAppSelector } from '@redux/store'

import clsx from 'clsx'
import { FC, useRef } from 'react'
import s from './Overlay.module.scss'
export type OverlayHandlerProps = {}

const Overlay: FC<OverlayHandlerProps> = ({ ...args }) => {
  const navOpen = useAppSelector(selectNavOpen)
  const ref = useRef<HTMLDivElement>(null)
  const dispatch = useAppDispatch()
  const overlayOpen = navOpen

  const clear = () => {
    if (navOpen) dispatch(setOnFlyoutWillClose())
  }

  return (
    <div
      ref={ref}
      className={clsx(s.root, { [s.open]: overlayOpen })}
      onClick={() => clear()}
    ></div>
  )
}

export default Overlay
